<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
        <div class="searchBox">

            <div class="searchGroup">
                <label>编号：</label>
                <el-input v-model="search_Obj.f_shell_num" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card class="box-card">
        <div class="mainBody">
        <div class="btnBox">
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
            <div class="dataBox">
                                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                                    <el-table-column prop="shell_num" label="编号" sortable="custom"></el-table-column>
                                    <el-table-column prop="lock_sn" label="序列号" sortable="custom"></el-table-column>
                                    <el-table-column prop="holder" label="持有人" sortable="custom"></el-table-column>
                                    <el-table-column prop="bind_user_count" label="绑定用户数" sortable="custom"></el-table-column>
                                    <el-table-column prop="create_time" label="添加时间" sortable="custom"></el-table-column>
                                    <el-table-column label="操作" width="240" align="center">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox">
                                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                            </div>
            <UserList
                                width="1100px"
                                :code="code"
                                title="推送用户管理"
                                :isshow="infoshow"
                                @on-save-ok="bindOk"
                                @on-close="bindOk">
                            </UserList>
        </div>
    </el-card>
</div>
        <Edit
                            width="600px"
                            :id="model_id"
                            :title="edit_title"
                            :isshow="editshow"
                            @on-close="closeEditDialog"
                            @on-save-ok="saveOk">
                        </Edit>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import UserList from "./userlist"
import listutil from "@/libs/listutil"

export default {
    name: 'cryptoDogList',
    mixins: [listutil],
    components: {Edit, Btns, LabBtns, UserList},
    data() {
        return {
            m_name: '测试',
            menu_id: 1150,
            list_url: "/api/admin/cryptodog/list",
            search_Obj: {
                f_shell_num: '',
            },
            del_Obj:{
                url:'/api/admin/cryptodog/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            code: '',
        };
    },
    methods: {
        bind(index, row) {
            this.code = row.shell_num
            this.infoshow = true
        },
        bindOk(){
            this.infoshow = false
            this.getListData()
        }
    }
};
</script>